/**
 * Replace timestamp with specific options to custom types.
 *
 * Replaces timestamp("field", { withTimezone: true, mode: 'string' })
 * with customTimestamptz("field")
 */

/**
 * Replace timestamp with timezone and string mode to customTimestamptz.
 *
 * @param source - The schema source code
 * @returns Object with replaced text and count of replacements
 */
export function replaceTimestampWithCustomTypes(source: string): { text: string; replaced: number } {
  let replaced = 0;

  // Match timestamp with any options: timestamp("field", { ... })
  const pattern = /timestamp\((['"])(.*?)\1,\s*(\{[^}]*\})\)/g;

  const text = source.replace(pattern, (match, quote, fieldName, options) => {
    // Check if options contain both withTimezone: true and mode: 'string'
    const hasWithTimezone = /withTimezone:\s*true/.test(options);
    const hasModeString = /mode:\s*['"]string['"]/.test(options);

    if (hasWithTimezone && hasModeString) {
      replaced += 1;
      return `customTimestamptz(${quote}${fieldName}${quote})`;
    }

    // Return original if conditions not met
    return match;
  });

  return { text, replaced };
}

/**
 * Replace .defaultNow() with .default(sql`CURRENT_TIMESTAMP`)
 * for custom timestamp types that don't support defaultNow().
 *
 * @param source - The schema source code
 * @returns Object with replaced text and count of replacements
 */
export function replaceDefaultNowWithSql(source: string): { text: string; replaced: number } {
  let replaced = 0;

  // Match .defaultNow() and replace with .default(sql`CURRENT_TIMESTAMP`)
  const pattern = /\.defaultNow\(\)/g;

  const text = source.replace(pattern, () => {
    replaced += 1;
    return '.default(sql`CURRENT_TIMESTAMP`)';
  });

  return { text, replaced };
}
